import { checkWhitelist } from "./helper"
import { MdFormat, ShowMarkdownMode } from "./types"

export const md2html = (s:string, activePar:number|null, whitelist:MdFormat[]|null = null, showMarkdown:ShowMarkdownMode='per-paragraph') => {
  //console.log(`Do markup(${s})`)
  var lines:string[] = s.split("\n")
  var i:number = 0
  var inCodeBlock = false
  var paragraphType:MdFormat|null = null
  var previousParagraphType:MdFormat|null = null
  const allowed = (t:MdFormat) => { return checkWhitelist(t, whitelist) }
  return lines.map((s) => {
    //console.log(`Process line ${i}: ${s}`)
    const classes:{[className:string]:Boolean} = {}
    var matches

    if (allowed('Codeblock') && (s.match(/^```/))) {
      inCodeBlock = !inCodeBlock
      if (inCodeBlock) s = '<p><span class="hinting-x">```</span>' + (s.replace(/^```/, '').length ? '<span class="code-heading">' + s.replace(/^```/, '') + '</span>':'') + '</p>'
      else s = '<p><span class="hinting-x">```</span></p>'
      classes['code'] = true
      paragraphType = 'Codeblock'
    }
    else {

      if (inCodeBlock) {
        s = `<p>${s.replace(/[\n\t\t]/g,'').length ? s : '<br />'}</p>`
      }
      else {
        if (allowed('Bold'))           s = s.replace(/([^\\]|^)\*\*([^\*^\\]+)\*\*/g, '$1<b><span class="hinting">**</span>$2<span class="hinting">**</span></b>')
        if (allowed('Emphasis'))       s = s.replace(/([^\*^\\]|^)\*([^\*^\\]+)\*([^\*]|$)/g, '$1<i><span class="hinting">*</span>$2<span class="hinting">*</span></i>$3')
        if (allowed('Underline'))      s = s.replace(/([^\\]|^)_([^_]+)_/g, '$1<u><span class="hinting">_</span>$2<span class="hinting">_</span></u>')
        if (allowed('Strikethrough'))  s = s.replace(/([^\\]|^)~([^~]+)~/g, '$1<s><span class="hinting">~</span>$2<span class="hinting">~</span></s>')
        if (allowed('Code'))           s = s.replace(/([^\\]|^)`([^`^\\]+)`/g, '$1<code><span class="hinting">`</span>$2<span class="hinting">`</code></u>')

        s = s.replace(/([\\])([^\\])/g, '<span class="hinting">$1</span>$2')

        if (allowed('AtMention')) s = s.replace(/( | |^)@\[([^\]]+)\]\(([^\)]+)\)/g, (all, pre, name, userId) => {
            return `${pre}<a href="${userId}" target="_blank" data-userId="${userId}" title="User ${userId}" class="user"><span class="hinting">@[</span>${name}<span class="hinting">](${userId})</span></a>`
        })

        if (allowed('Link')) s = s.replace(/( | |^)\[([^\]]+)\]\(([^\)]+)\)/g, (all, pre, name, url) => {
            const realUrl = (url.match(/:\/\//)) ? url : `http://${url}`
            return `${pre}<a href="${realUrl}" target="_blank" title="Link to: ${realUrl}"><span class="hinting">[</span>${name}<span class="hinting">](${url})</span></a>`
        })

             if ((allowed('Heading1')) && (s.match(/^#[  ]([^\n]+)/)))               { s = `<h1><span class="hinting"># </span>${s.replace(/^#[  ]/, '')}</h1>`; paragraphType='Heading1' }
        else if ((allowed('Heading2')) && (s.match(/^##[  ]([^\n]+)/)))              { s = `<h2><span class="hinting">## </span>${s.replace(/^##[  ]/, '')}</h2>`; paragraphType='Heading2' }
        else if ((allowed('Heading3')) && (s.match(/^###[  ]([^\n]+)/)))             { s = `<h2><span class="hinting">### </span>${s.replace(/^###[  ]/, '')}</h2>`; paragraphType='Heading3' }
        else if ((allowed('Blockquote')) && (s.match(/^>[  ]([^\n]+)/)))             { s = `<div class="blockquote"><span class="hinting">> </span>${s.replace(/^>[  ]/, '')}</div>`; paragraphType='Blockquote' }
        else if ((allowed('UnorderedList')) && (matches = s.match(/^([  ]{12}|[  ]{8}|[  ]{4}|[  ]{0})-[  ]([^\n]+)/))) {
          paragraphType='UnorderedList'
          const indent = matches[1].length / 4
          const className = 'bullets' + (` indent-${indent}`)
          const prefix = indent ? `<span class="indent-hinting">${matches[1]}</span>` : ''
          s = `<div class="${className}">${prefix}<span class="hinting">- </span>${matches[2]}</div>`;
        }
        else if ((allowed('OrderedList')) && (matches = s.match(/^([  ]{12}|[  ]{8}|[  ]{4}|[  ]{0})([0-9]+)\.[  ]+([^\n]+)/))) { //(s.match(/^[0-9]+\.[  ]+([^\n]+)/))) {
          paragraphType='OrderedList'
          const indent = matches[1].length / 4
          const className = 'enum' + (` indent-${indent}`)
          const prefix = indent ? `<span class="indent-hinting">${matches[1]}</span>` : ''
          s = `<div class="${className}">${prefix}<span class="hinting">${matches[2]}. </span>${matches[3]}</div>`
        }
        else if (matches = s.match(/^([  ]{12}|[  ]{8}|[  ]{4})([^  ][^\n]+)/)) {
          const indent = matches[1].length / 4
          s = `<p class="indent-${indent}"><span class="indent-hinting">${matches[1].replaceAll(' ', ' ')}</span>${matches[2]}</p>`
        }
        else { s = `<p>${s.replace(/[\n\t\t]/g,'').length ? s : '<br />'}</p>`; paragraphType=null }
      }
    }

    // Add Classes
    if ((i === activePar) || (showMarkdown=='always')) classes['show-md'] = true
    if (inCodeBlock) classes['code'] = true

    if ((paragraphType === 'Blockquote' && previousParagraphType !== 'Blockquote') || (paragraphType !== 'Blockquote' && previousParagraphType === 'Blockquote')) classes['topspace'] = true
    if ((paragraphType === 'Codeblock' && previousParagraphType !== 'Codeblock') || (paragraphType !== 'Codeblock' && previousParagraphType === 'Codeblock')) classes['topspace'] = true

    //console.log(`---> classes when working on ${s}:` + Object.keys(classes).join(', '), inCodeBlock)
    // Add classes
    if (Object.keys(classes).length) {
      var matches
      if (matches = s.match(/^<([^ >]+) class="([^"]+)"/)) {
        matches[2].split(' ').forEach(className => classes[className] = true)
        s = s.replace(/^<([^ ]+) class="([^"]+)"/, `<$1 class="${Object.keys(classes).join(' ')}"`)
      }
      else {
        s = s.replace(/<([^>]+)>/, `<$1 class="${Object.keys(classes).join(' ')}">`)
      }
    }
    previousParagraphType = paragraphType
    i++
    return s
  }).join("\n")
}

export const md2text = (value:string, whitelist:MdFormat[]|null=null) => {
  const s = md2html(value, null, whitelist)
  return s.replace(/<[^>]+>/g, '')
}